<div class="radar-chart-container">
  <div class="chart-wrapper">
    <canvas #chartCanvas></canvas>
  </div>
</div>
